import { prodapiAxiosClient } from "./prodApiClient";

const postNpeDispatch = (type, payload) => {
  return prodapiAxiosClient.get(`/api/v1/netsuite/npeDispatch`, {
    type: type,
    data: payload,
  });
};

const getShippingLocations = () => {
  return prodapiAxiosClient.get(`/api/v1/netsuite/getShippingLocations`);
};


const fetchPoNumbers = (poIds) => {
  return prodapiAxiosClient.post(`/api/v1/netsuite/fetchPoNos`,{ "poIds": poIds });
};

const getMseList = (poIds) => {
  return prodapiAxiosClient.get(`/api/v1/netsuite/getMseLists`);
};



const netsuiteApi = { postNpeDispatch, getShippingLocations, fetchPoNumbers, getMseList };
export default netsuiteApi;
